<ng-container *ngIf="activatableItemCount && activatableItemCount.activatableItem as activatableItem">
  <td
    [ngClass]="{
      disabled: !!activatableItemCount?.activatableItem?.restrictedReason
    }"
    class="product-section"
  >
    <div class="product-name-column">
      <va-icon
        class="indent"
        [diameter]="32"
        [iconName]="activatableItem.name"
        [iconUrl]="activatableItem.icon"
      ></va-icon>
      <div class="package-info">
        <p class="package-name">
          {{
            activatableItem.name +
              (usesEdition() && activatableItemCount.editionName ? ' | ' + activatableItemCount.editionName : '')
          }}
        </p>
        <span
          class="item-status-green"
          *ngIf="
            activatableItemCount.status === activatedStatus &&
            !activatableItem.isTrial &&
            !activatableItemCount.currentlyActivatedEditionName
          "
        >
          Currently active
        </span>
        <span
          class="item-status-green"
          *ngIf="
            activatableItemCount.status === activatedStatus &&
            !activatableItem.isTrial &&
            activatableItemCount.currentlyActivatedEditionName
          "
        >
          {{
            'ACTIVATION.SELECTION_PAGE.PACKAGE_ACTIVATION_TABLE.EDITION_IS_CURRENTLY_ACTIVE'
              | translate
                : {
                    editionName: activatableItem.name + ' | ' + activatableItemCount.currentlyActivatedEditionName
                  }
          }}
        </span>
        <span
          class="item-status-yellow"
          *ngIf="activatableItemCount.status === cancelledStatus && !activatableItem.isTrial"
        >
          {{ 'ACTIVATION.SELECTION_PAGE.CANCELED' | translate }}
        </span>
        <span
          class="item-status-green"
          *ngIf="activatableItemCount.status === pendingStatus && !activatableItem.isTrial"
        >
          {{ 'ACTIVATION.SELECTION_PAGE.PENDING' | translate }}
        </span>
      </div>
    </div>
  </td>

  <ng-container *ngIf="!activatableItem.restrictedReason; else restricted">
    <td
      [ngClass]="{
        disabled: !!activatableItemCount?.activatableItem?.restrictedReason
      }"
    >
      <div class="quantity" *ngIf="activatableItem.allowMultipleActivations">
        {{ activatableItemCount.quantity }}
      </div>
    </td>
    <td
      *ngIf="!hidePricing"
      [ngClass]="{
        disabled: !!activatableItemCount?.activatableItem?.restrictedReason
      }"
      class="pricing-section"
    >
      <app-activation-table-pricing
        [pricing]="activatableItem.pricing"
        [billingId]="getBillingId()"
      ></app-activation-table-pricing>
    </td>
  </ng-container>

  <ng-template #restricted>
    <td
      [ngClass]="{
        disabled: !!activatableItemCount?.activatableItem?.restrictedReason
      }"
    ></td>
    <td
      [ngClass]="{
        disabled: !!activatableItemCount?.activatableItem?.restrictedReason
      }"
      class="pricing-section"
    >
      {{ activatableItem.restrictedReason }}
    </td>
  </ng-template>
</ng-container>
